module.exports = __webpack_public_path__ + "static/media/icono-chef2.4a87adb0.jpg";